import { api, download } from "../helpers";

export const getUsers = (payload, token) =>
	api("/users", "GET", undefined, { ...payload, type: "ADMIN" }, token);

export const createUser = (payload, token) =>
	api("/auth/register", "POST", payload, {}, token);

export const updateUserStatus = ({ id, ...payload }, token) =>
	api("/users/" + id + "/status", "PUT", payload, undefined, token);

export const exportUsers = (params, token) =>
	download("/users/export", params, token);
